module.exports = __webpack_public_path__ + "static/media/logo.a612570f.png";